import Box from "@mui/material/Box";
import { NavRow } from "./NavRow";
import { DESTINATIONS } from "./navItems";
import { PHONE_FOOTER_HEIGHT } from "./layout";
import type { Destination } from "./routes";
import { useT } from "../../shared/i18n";

/**
 * Phone footer: Catalog / Browse / Items / Photos, 56px, always visible —
 * including on detail, edit, search and task views (spec §2; catalog-selector
 * 02 adds the fourth tab). It never hides behind the keyboard: the shell
 * applies the visualViewport height.
 */
export function PhoneFooter({
  destination,
  onNavigate,
}: {
  destination: Destination | null;
  onNavigate: (path: string) => void;
}) {
  const t = useT();
  return (
    <Box
      component="nav"
      aria-label={t("primaryNav")}
      data-testid="phone-footer"
      sx={{
        display: "flex",
        flexShrink: 0,
        height: PHONE_FOOTER_HEIGHT,
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        pb: "env(safe-area-inset-bottom)",
        boxSizing: "content-box",
      }}
    >
      {DESTINATIONS.map(({ destination: itemDestination, path, labelKey, icon }) => (
        <NavRow
          key={itemDestination}
          icon={icon}
          label={t(labelKey)}
          orientation="vertical"
          selected={itemDestination === destination}
          testId={`nav-${itemDestination}`}
          onClick={() => onNavigate(path)}
        />
      ))}
    </Box>
  );
}
